export default "/front/page-privacy-policy/static/arrow-back-0fe322.svg";